<template>
  <div class="navbar">
    <Hamburger
      class="hamburger-container"
      :is-active="sidebar.opened"
      @toggleClick="toggleSideBar"
    />

    <Breadcrumb class="breadcrumb-container" />

    <div class="right-menu">
      <el-dropdown trigger="click">
        <div class="flex items-center">
          <span>{{ nickname }}</span>
          <img class="h-10 w-10 mx-3 rounded-full" :src="avatar" alt="" />
          <i class="el-icon-caret-bottom mr-3"></i>
        </div>
        <el-dropdown-menu slot="dropdown" class="text-center">
          <el-dropdown-item>
            <router-link to="/">
              <el-dropdown-item> 首 页 </el-dropdown-item>
            </router-link>
          </el-dropdown-item>
          <el-dropdown-item divided @click.native="logout">
            <span style="display: block">退 出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import { removeToken } from '@/utils/cookies'
import Default_Avatar from '../../assets/404_images/404.png'

export default {
  data() {
    return {}
  },
  components: {
    Breadcrumb,
    Hamburger,
    Default_Avatar,
  },
  computed: {
    ...mapState('app', ['sidebar']),
    ...mapState('user', ['avatar', 'nickname']),
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      removeToken()
      await this.$store.dispatch('user/logout')
      this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    },
  },
  mounted() {
    console.log(mapState('user'))
  },
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }
  }
}
</style>
